export default __webpack_public_path__ + "static/media/bg-engage-footer.fe2f0c39.svg";